(() => {
  const validProductionHubs = new Set(['Johannesburg', 'Cape Town']);

  const cartError = (code) => {
    const error = new Error(code);
    error.code = code;
    return error;
  };

  const resolveCartData = async ({ fetchImplementation, productionHub, rootPath }) => {
    if (!validProductionHubs.has(productionHub)) {
      throw cartError('production_hub_missing');
    }

    let response;
    try {
      response = await fetchImplementation(`${rootPath}cart.js`, {
        headers: { Accept: 'application/json' },
      });
    } catch (_error) {
      throw cartError('cart_unavailable');
    }

    if (!response.ok) throw cartError('cart_unavailable');

    let cart;
    try {
      cart = await response.json();
    } catch (_error) {
      throw cartError('cart_unavailable');
    }

    if (typeof cart?.token !== 'string' || !cart.token || !Array.isArray(cart.items) || !cart.items.length) {
      throw cartError('cart_unavailable');
    }

    const lineItems = cart.items.map((item) => {
      if (item.selling_plan_allocation || Object.keys(item.properties || {}).length || item.has_components) {
        throw new Error('Subscriptions, bundles and personalised items need assistance from our team.');
      }
      const variantId = String(item?.variant_id || '');
      const quantity = Number(item?.quantity);
      if (!/^\d+$/.test(variantId) || !Number.isInteger(quantity) || quantity < 1) {
        throw cartError('cart_unavailable');
      }
      return {
        variantId: `gid://shopify/ProductVariant/${variantId}`,
        quantity,
      };
    });

    const expectedUnitPrices = window.MyWasteBranchCart.expectedPrices(cart, productionHub);
    return { cartToken: cart.token, lineItems, productionHub, expectedUnitPrices };
  };

  window.MyWasteDeliveryRequest = Object.freeze({ resolveCartData });

  const initialize = () => {
    document.querySelectorAll('[data-pickup-checkout-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      let busy = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy) return;
        busy = true;
        const button = form.querySelector('[data-pickup-submit]');
        const error = form.querySelector('[data-pickup-error]');
        const original = button.textContent;
        button.disabled = true;
        button.textContent = 'Confirming prices and pickup…';
        error.hidden = true;
        try {
          const productionHub = window.localStorage.getItem('mywaste-production-hub');
          const cartData = await resolveCartData({ fetchImplementation: window.fetch.bind(window), productionHub, rootPath: window.Shopify?.routes?.root || '/' });
          const fingerprint = JSON.stringify(cartData);
          const key = 'mywaste-pickup-checkout';
          let attempt;
          try { attempt = JSON.parse(window.sessionStorage.getItem(key)); } catch {}
          if (attempt?.fingerprint !== fingerprint) {
            attempt = { fingerprint, requestId: window.crypto.randomUUID() };
            window.sessionStorage.setItem(key, JSON.stringify(attempt));
          }
          const response = await fetch(form.action, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ ...cartData, fulfilment: 'pickup', requestId: attempt.requestId }),
          });
          const result = await response.json();
          if (!response.ok || !result.ok || !result.checkoutUrl) throw new Error(result.message || 'Checkout could not be opened. Your cart is unchanged.');
          if (window.localStorage.getItem('mywaste-production-hub') !== productionHub) throw new Error('Your branch changed. Review your cart before continuing.');
          const url = new URL(result.checkoutUrl);
          if (url.protocol !== 'https:' || !['mywaste.co', 'eqf0qz-dd.myshopify.com'].includes(url.hostname)) throw new Error('Invalid checkout link.');
          window.location.assign(url.href);
        } catch (failure) {
          error.textContent = failure.message || 'Checkout could not be opened. Please try again.';
          error.hidden = false;
          button.disabled = false;
          button.textContent = original;
          busy = false;
        }
      });
    });
  };
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
